module.exports = __webpack_public_path__ + "static/media/REA_BG.b2192929.jpg";